<template>
  <div class="wrapper">
    <!-- 返回按钮 -->
    <div class="back-btn-box">
      <button-a class="goBackBtn" color="#707070" bgcolor="transparent" @click.native="$router.go(-1)">
        <i class="el-icon-back"></i> 返回
      </button-a>
    </div>
       <!-- 属性面板 -->
    <div class="infomation white_box">
      <img class="user_picture" src="@/assets/icons/company@2x.png" alt="">
      <div class="key-value">
        <div class="key">
          <p class="font_14_gray">所属企业</p>
          <p class="font_14_gray">薪资月份</p>
        </div>
        <div class="value">
          <p class="font_14_black">{{customerName}}</p>
          <!-- <p class="font_14_black">Fox’s食品有限公司</p> -->
          <p class="font_14_black">{{salaryMonth}}</p>
        </div>
      </div>
      <div class="key-value">
        <div class="key">
          <!-- <p class="font_14_gray">所属组织</p> -->
          <p class="font_14_gray">薪资批次名称</p>
        </div>
        <div class="value">
          <p class="font_14_black">{{salarybatchesName}}</p>
        </div>
      </div>
    </div>

    <div class="result white_box">

    <!-- 标签筛选 -->
    <div class="tags white_box">
      <div class="tag-group">
        <p class="font_14_black">发放状态：</p>
        <filter-tag
          :class="{active: paystatus[0]}"
          @click.native="change('paystatus', 0)"
          name="待发薪"
        />
        <filter-tag
          :class="{active: paystatus[1]}"
          @click.native="change('paystatus', 1)"
          name="申请中"
        />
          <filter-tag
          :class="{active: paystatus[2]}"
          @click.native="change('paystatus', 2)"
          name="提交银行受理中"
        />
          <filter-tag
          :class="{active: paystatus[3]}"
          @click.native="change('paystatus', 3)"
          name="退票"
        />
          <filter-tag
          :class="{active: paystatus[4]}"
          @click.native="change('paystatus', 4)"
          name="银行发放成功"
        />
        <!-- 操作选项 -->
        <div class="options">
          <div>
            <el-input style="width: 250px" class="custom-es" size="medium" placeholder="请输入员工姓名/证件号码/手机号码" v-model="input" @change="employeeNameChange" clearable></el-input>
          </div>
        </div>
      </div>
    </div>
      <!-- 表格
        ref="multipleTable" 引用名
        :data="tableData" 绑定数据
        :header-row-style="headerRowStyle" 表头样式
        :row-style="rowStyle" 行样式
      -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        :header-row-style="headerRowStyle"
        :header-cell-style="headerCellStyle"
        :row-style="rowStyle"
        style="width: 100%;font-size: 14px;color: #707070;border: 1px solid #e5e5e5;border-radius: 6px"
        @selection-change="handleSelectionChange"
      >
        <!-- 占位列 -->
        <el-table-column width="35"></el-table-column>
        <!-- 多选框 -->

        <el-table-column type="index" label="序号" :width="tableWidth[0] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="employeeName" label="员工姓名" :width="tableWidth[1] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="idCard" label="证件号码" :width="tableWidth[2] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column  label="应发薪资" :width="tableWidth[3] | translateWidth" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.totalPayAmount.toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column  label="个税金额" :width="tableWidth[4] | translateWidth" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.incomeTax.toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="totalDeduction" label="应扣薪资" :width="tableWidth[5] | translateWidth" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.totalDeduction.toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="incomeTax" label="实发薪资" :width="tableWidth[6] | translateWidth" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.finalPayAmount.toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="payStatusName" label="发放状态" :width="tableWidth[7] | translateWidth" show-overflow-tooltip>
        </el-table-column>

        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="font_14_orange pointer view" @click="view(scope)">查看</span>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, sizes, jumper, ->, slot"
        :total="total"
        :pager-count="5"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { Get } from "@/js/http.js";
import { dateConvert,Filter, translateWidth } from "@/js/tool.js";

export default {
  components: {},
  props: {},
  data() {
    return {
      tableWidth: [94, 162, 270, 180, 190, 190, 190, 190],

      tableData:[],
      total:0,
      input: "",  // 员工搜索输入
      customerName:"",
      salarybatchesName:"",
      salaryMonth:"",
      salarySummaryId: this.$route.params.salarySummaryId,
      page: 1, // 当前页码
      size: 10, // 每页条数
      paystatus:{
        0:true,
        1:true,
        2:true,
        3:true,
        4:true
      }, // 公积金筛选
      value: [],
      multipleSelection: [],  // 表格行选择
      rowStyle: { // 表格内容行样式
        height: translateWidth(60)+"px",
        backgroundColor: "#fff"
      },
      headerRowStyle: { // 表格头行样式
        height: translateWidth(68)+"px",
        fongSize: "14px",
        color: "#000",
        backgroundColor: "#fafbff"
      },
      headerCellStyle: { // 表格头单元格样式
        backgroundColor: "transparent"
      },
      activeTab: 'second', // 当前选择的选项卡
      activeNames: [], // 展开的折叠面板
    };
  },
  watch: {},
  computed: {
    // 查询表格跳过的条数
    SkipCount() {
      return (this.page - 1) * this.size;
    },
  },
  methods: {
    // 点击筛选标签 dataName: String，key: Number
    change(dataName, key) {
     /*  this[dataName][key] = !this[dataName][key];
      this[dataName] = this[dataName].slice();
      this.updateTable(); */
      let ischanged = Filter.call(this, dataName, key);
      if (ischanged) {
        this.page = 1;
        this.getTableData();
      }
    },
    getData(){
      Get(`api/v1/salary-summaries/${this.salarySummaryId}/brief`).then(res=>{
        this.customerName=res.data.customerName;
        this.salarybatchesName=res.data.salarySummaryName;
        this.salaryMonth=res.data.salaryDate;
      }).catch(() => {
      });
    },
    getTableData(){
      let Paystatus=[];
      for(let i in this.paystatus){
        if(this.paystatus[i]==true){
          Paystatus.push(i);
        }
      }
      Get(`/api/v1/salary-summaries/${this.salarySummaryId}/employee-salaries`, {
        Keyword:this.input,
        PaymentStatuses:Paystatus,
        MaxResultCount: this.size, // 每页条数
        SkipCount: this.SkipCount // 跳过条数
      }).then(res=>{
        this.total = res.data.totalCount;
        this.tableData=res.data.items;
      }).catch(() => {
      });
    },
    // 日期格式转换
    date(dateStr) {
      return dateConvert(dateStr);
    },
    // 点击查询按钮
    query() {
      this.page=1;
      this.getTableData();
    },
    // 表格项选中
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    employeeNameChange(){
      this.getTableData();
    },
    // 每页条数选择
    handleSizeChange(v) {
      this.size = v;
      this.getTableData();
    },
    // 页码选择
    handleCurrentChange(v) {
      this.page = v;
      this.getTableData();
    },
    translateWidth(num) {
      return translateWidth(num)
    },
    // 绑定窗口缩放事件
    ifResize() {
      window.addEventListener("resize", this.resize);
    },
    resize() {
      this.tableWidth = JSON.parse(JSON.stringify(this.tableWidth))
      this.headerRowStyle = { // 表格头行样式
        height: translateWidth(68)+"px",
        fongSize: "14px",
        color: "#000",
        backgroundColor: "#fafbff"
      },
      this.rowStyle = { // 表格内容行样式
        height: translateWidth(60)+"px",
        backgroundColor: "#fff"
      }
    }
  },
  created() {},
  mounted() {
    this.getData();
    this.getTableData();

    this.ifResize();

  },
  beforeDestroy() {
    // 解除事件
    window.removeEventListener('resize', this.resize)
  }
};
</script>

<style lang="scss" scoped>
// 布局样式
.wrapper {
  padding: 32px 32px 24px;
  > div {
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .filter {
    display: flex;
    align-items: center;
    padding: 22px 48px;
  }
  .tags {
    padding: 48px;
    .tag-group {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .options {
      flex: 1;
      div {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .sum-group {
    display: flex;
    padding: 24px 48px 24px;
    align-items: center;
    .sum {
      width: 240px;
      &:last-of-type {
        flex: 1;
      }
    }
  }
  .result {
    padding: 30px 48px 48px;
  }
}
/** 
  补充样式
*/ 
// 筛选标签
.filter-tag {
  margin-left: 6px;
  margin-right: 24px;
}
// 查询按钮
.query {
  margin-right: 32px;
}
// 导出按钮
.export {
  margin-right: 50px;
}
// 查看按钮
.view {
  margin-right: 18px;
}
// 通知详情按钮
.detail {
  margin-right: 18px;
}

// 属性面板
.infomation {
  display: flex;
  align-items: center;
  padding: 30px 84px;
}
.user_picture {
  margin-right: 64px;
  width: 104px;
  height: 104px;
}
// 键值对
.key-value {
  display: flex;
  justify-content: center;
  align-self: stretch;
  margin-right: 150px;
  margin-top: 15px;
  &:last-child {
    margin-right: 0;
  }
  .key {
    margin-right: 50px;
    p {
      text-align: right;
    }
  }
  p {
    margin-bottom: 32px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}

// 小标签
.tag {
  margin-left: 16px;
}

// 选项卡
.el-tabs {
  ::v-deep .el-tabs__nav .el-tabs__item {
    padding: 0 49px;
    height: 64px;
    font-size: 16px;
    line-height: 64px;
    &.is-active {
      color: #f26828;
    }
    &:hover {
      color: #f26828;
    }
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #f26828;
  }
}

// 轮播
.block {
  width: 1180px;
  .row {
    justify-content: center;
  }
  .contract {
    display: flex;
    align-items: center;
    width: 1020px;
    height: 450px;
    padding: 40px 35px;
    background-color: #fafbff;
    border-radius: 8px;
  }
  .tag {
    margin-left: 0;
    margin-right: 10px;
  }
  .pdf {
    display: flex;
    width: 168px;
    cursor: pointer;
  }
  .pdf_icon {
    margin-right: 15px;
  }
}

// 折叠面板
.fold {
  overflow: hidden;
  padding: 32px 64px;
  .el-collapse {
    border: none;
    .row {
      padding-top: 32px;
      padding-left: 50px;
    }
    ::v-deep .el-collapse-item__header {
      border: none;
      img {
        transition: all 0.6s ease;
      }
    }
    ::v-deep .el-collapse-item__wrap {
      border: none;
    }
    ::v-deep .el-collapse-item__content {
      padding-bottom: 0;
    }
    ::v-deep .el-collapse-item.is-active {
      img {
        transform: rotate(180deg);
        transition: all 0.6s ease;
      }
    }
    ::v-deep .el-collapse-item__arrow {
      display: none;
    }
  }
  .fold_title {
    display: flex;
    align-items: center;
    // padding-left: 64px;
    .money {
      width: 236px;
      height: 46px;
      margin-left: 40px;
      margin-right: 58px; 
      line-height: 46px;
      text-align: center;
      background-color: #eff2fe;
      border-radius: 8px;
    }
    .fold_btn {
      display: flex;
      align-items: center;
      .fold_icon {

      }
    }
  }
}
// 补充样式
.wrapper .tags .tag-group[data-v-68b1054e]:last-child {
    margin-bottom: 0px;
    margin-left: -45px;
    margin-top: -35px;
}

.back-btn-box {
  margin-bottom: 32px;
}
.goBackBtn {
  font-size: 16px !important;
  border: none !important;
  border-color: transparent !important;
}

</style>